import { useIsMutating } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

/**
 * 07/10/2026 (người dùng yêu cầu) — lớp phủ toàn màn hình + vòng xoay khi có thao tác GHI đang chạy (mọi `useMutation`: lưu, duyệt, gửi, xóa…):
 * chặn bấm thêm / bấm lặp cho tới khi máy chủ trả lời. Hiện sau {@link DELAY_MS} để thao tác nhanh không bị nháy.
 *
 * Mutation chạy nền không chặn màn hình (đánh dấu đã đọc, xem trước mẫu…) khai `meta: { silent: true }`.
 * Truy vấn đọc (useQuery) KHÔNG kích hoạt lớp phủ — trang tự hiện trạng thái tải của nó.
 */
const DELAY_MS = 250;

export function BusyOverlay() {
  const busy = useIsMutating({ predicate: (m) => m.options.meta?.silent !== true }) > 0;
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!busy) {
      setShown(false);
      return;
    }
    const t = window.setTimeout(() => setShown(true), DELAY_MS);
    return () => window.clearTimeout(t);
  }, [busy]);
  if (!busy) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      // chặn chuột ngay từ đầu (kể cả trong 250 ms chưa hiện) — tránh bấm đúp gửi trùng
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        cursor: 'progress',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: shown ? 'rgba(15, 23, 42, 0.28)' : 'transparent',
        transition: 'background 0.15s',
      }}
      onKeyDown={(e) => e.preventDefault()}
    >
      {shown ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
            padding: '20px 28px',
            background: 'var(--kx-surface, #fff)',
            borderRadius: 14,
            boxShadow: '0 12px 32px rgba(0,0,0,.18)',
          }}
        >
          <span className="kx-busy-spinner" aria-hidden="true" />
          <span style={{ fontSize: 13, color: 'var(--kx-ink, #0f172a)' }}>Đang xử lý…</span>
        </div>
      ) : null}
    </div>
  );
}
